exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status {\n  display: none;\n}\n.name {\n  display: block;\n  padding: 0;\n  margin: 0;\n  /*color: #409EFF;*/\n}\n.draggable-tag{\n  display: inline-block;\n  width: 100px;\n  height: 100px;\n  margin: 5px;\n  text-align: center;\n}\n.banner-img {\n  display: block;\n  text-align: center;\n  width: 100%;\n  height: 50px;\n  background-size: cover;\n  background-position: center;\n}\n.banner-img img {\n  width: 50px;\n  height: 50px;\n}\n", ""]);

// exports
